import { ReactNode } from 'react';
import { View, ScrollView } from 'react-native';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { styles } from './styles';
import { Links } from '@/config/links';

export const MaxSessions = ({ children }: { children: ReactNode }) => {
  return (
    <ScrollView style={{ flexGrow: 0 }}>
      <View style={styles.maxDeviceListContainer}>
        <Text style={styles.maxDeviceListTitle}>Eingeloggte Geräte</Text>
        {children}
      </View>
      <View style={styles.maxDeviceInfo}>
        <Text> 💡 </Text>
        <Text>
          Falls Sie Ihren Patient:innen nur das Eigentraining einstellen
          möchten, können Sie sich{' '}
          <TextLink
            href={Links.nurEigentraining.href}
            className="text-blue-600"
          >
            hier{' '}
          </TextLink>
          auf beliebig vielen Geräten anmelden.
        </Text>
      </View>
    </ScrollView>
  );
};
